module.exports = __webpack_public_path__ + "static/img/deve8.172e7a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/deve8.png
// module id = sZTD
// module chunks = 1